import { types } from "mobx-state-tree";
import teams from './teams/teams';
import user from './user/user';
import sites from './sites/sites';
import clubs from './clubs/clubs';
import coaches from './coaches/coaches';
import videos from './videos/videos';
import metrics from './metrics/metrics';
import categories from './categories/categories';
import notifications from './notifications/notifications';
import meta from './meta/meta';

const RootStore = types.model("RootStore", {
  TeamsStore: types.optional(teams, {
    teams: []
  }), 
  UserStore: types.optional(user, {
    data: {}
  }), 
  SitesStore: types.optional(sites, {
    sites: []
  }), 
  ClubsStore: types.optional(clubs, {
    clubs: []
  }),
  CoachesStore: types.optional(coaches, {
    coaches: []
  }), 
  VideosStore: types.optional(videos, {
    videos: []
  }), 
  MetricsStore: types.optional(metrics, {}),
  CategoriesStore: types.optional(categories, {}), 
  NotificationsStore: types.optional(notifications, {
    count: 0
  }),
  MetaStore: types.optional(meta, {
    isLoading: false
  })
});

export default RootStore;